
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name finance.vcunicat.factory:UnicatHelper
   *
   * @description
   *
   */
  angular
    .module('vcfinance.unicat')
    .factory('UnicatHelper', UnicatHelper);
  
  
  UnicatHelper.$inject = ['Unicat', '$uibModal', '$log', 'Rlog'];
  
  function UnicatHelper(Unicat, $uibModal, $log, Rlog) {
    let UnicatHelperBase = {};
    
    UnicatHelperBase.editUnicat = editUnicat;
    UnicatHelperBase.addUnicat = addUnicat;
    
    
    function addUnicat(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><unicatform unicat="vm.unicat" parentsave="vm.childsave(unicat)" oncancel="vm.cancel()"></unicatnew></div>',
        controllerAs: 'unicataCtrl',
        controller: ['unicat', function () {
          let vm = this;
          vm.unicat = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(unicat) {
            Unicat.$create(unicat).$then(function (newunicat) {
              vm.created = true;
              success(newunicat);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ unicat-helper.addUnicat: ', err);
              Rlog.error('vcutils.unicat', 'unicat-helper.addUnicat', 'Creation of new SV failed: ', {error: err, unicat: unicat});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          unicat: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editUnicat(lunicat) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><unicatform unicat="unicateCtrl.unicat" parentsave="unicateCtrl.childsave(unicat)" oncancel="unicateCtrl.cancel()"></unicatform></div>',
        controllerAs: 'unicateCtrl',
        controller: ['unicat', function (sunicat) {
          let vm = this;
          vm.unicat = sunicat;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(unicat) {
            // vm.unicat = angular.copy(unicat);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in unicat) {
              if (unicat.hasOwnProperty(key)) {
                vm.unicat[key] = unicat[key];
              }
            }
            
            if (vm.unicat.$hasPendingActions()) {
              vm.unicat.$cancel();
              vm.unicat.$save();
              cancel();
            }
            else {
              vm.unicat.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          unicat: function () {
            return lunicat;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return UnicatHelperBase;
  }
}());
